import { makeStyles } from '@material-ui/core/styles';

import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
  content: {
    width: '581px',
    height: '400px',

    '& section > div:first-of-type': {
      height: 120,
      width: 581,
      display: 'flex',
      alignItems: 'center',
      marginLeft: 0,
      marginRight: 0,
    },

    '& section > p:first-of-type': {
      fontSize: fonts.sizes.xsmall,
      fontWeight: fonts.weights.normal,
      marginTop: spacing.xsmall,
      marginLeft: spacing.xsmall,
      letterSpacing: '0.4px',
      color: colors.gray,
    },

    '& aside > div': {
      paddingLeft: spacing.xxsmall,
      paddingRight: spacing.xxsmall,
      paddingTop: spacing.xxsmall,
    },

    '& aside > div:first-of-type': {
      paddingTop: spacing.small,
    },

    '& aside > div > div:first-of-type': {
      alignItems: 'center',
    },

    '& h4': {
      fontSize: fonts.sizes.small,
      fontWeight: fonts.weights.normal,
      color: colors.uploadedItemLegend,
      lineHeight: '20px',
    },
  },
});

export default useStyles;
